import React, { FC } from 'react';
import FormContainer from '../../Shared/FormContainer/FormContainer';
import { FormRadioWrapper, FormRadioContainer, FormLabel, FormItemContainer, FormItemDescription, Price, PriceTitleContainer, From, MainTitle } from '../styled';
import { FORM_RADIO_COMPONENT_TYPES } from '../types';
import { ErrorMessage } from '../../Shared/Shared';
import { isProductNoCharge } from '../helpers';
import { RequireAtLeastOne } from '../../../types';

interface FormRadioFromsProps {
  type: keyof typeof FORM_RADIO_COMPONENT_TYPES;
  formOptions: Record<string, any>;
  dataArr?: Record<string, any>[];
  onSubmit?: (data: Record<string, string[]>) => void;
  checkIfAvailable?: (productId: string) => boolean;
  borderColor?: string;
  loading?: boolean;
  defaultCheckedId?: string;
  isLoggedIn?: boolean;
  noNextButton?: boolean;
  AboveItemsElement?: () => JSX.Element;
  title?: string;
}

const FormRadioFroms: FC<FormRadioFromsProps> = ({
  type,
  formOptions,
  title,
  dataArr,
  onSubmit,
  checkIfAvailable = () => true,
  borderColor = 'gray',
  loading,
  defaultCheckedId,
  isLoggedIn,
  noNextButton,
  AboveItemsElement
}) => {
  const { title: defaultTitle, registerAs, requiredMessage } = FORM_RADIO_COMPONENT_TYPES[type];
  const { register, handleSubmit, formState } = formOptions;

  return (
    <FormRadioWrapper isLoggedIn={isLoggedIn}>
      <FormContainer
        onSubmit={handleSubmit(onSubmit)}
        title={title || defaultTitle}
        loading={loading}
        noPreviousButton
        error={formState?.errors?.[registerAs]}
        noNextButton={noNextButton}
        centerTitle={noNextButton}
      >
        <FormRadioContainer>
          {AboveItemsElement && <AboveItemsElement />}
          {dataArr?.map(data => {
            if (!data) return null;
            const { id, name } = data || {};

            return (
              <FormLabel key={id} borderColor={borderColor}>
                <input
                  {...register(registerAs, {
                    required: requiredMessage,
                    validate: checkIfAvailable
                  })}
                  type="checkbox"
                  value={id}
                  autoFocus
                  defaultChecked={id === defaultCheckedId}
                  disabled={!checkIfAvailable(id)}
                />
                <FormItemContainer disabled={!checkIfAvailable(id)}>
                  <PriceTitleContainer>
                    <MainTitle>{name || title}</MainTitle>
                  </PriceTitleContainer>
                </FormItemContainer>
              </FormLabel>
            );
          })}
        </FormRadioContainer>
        {formState?.errors?.[registerAs] && <ErrorMessage>{formState.errors[registerAs].message}</ErrorMessage>}
      </FormContainer>
    </FormRadioWrapper>
  );
};

export default FormRadioFroms;
